import { AxiosConfig } from "../AxiosConfig/AxiosConfig";
/**
 * Check if a user has premium access
 * @param tenantId tenant id
 * @param userId user id
 * @param appId app id
 */
export const getAdminCenterData = (tenantId, userId, appId, url) => {
    return new Promise((resolve, reject) => {
        const data = new URLSearchParams();
        data.append("tenantId", tenantId);
        data.append("userId", userId);
        data.append("appId", appId);
        fetch(url + "/teams-app/data", {
            method: "POST",
            body: data,
        })
            .then((res) => {
            return res.json();
        })
            .then((json) => {
            resolve(json);
        })
            .catch(() => {
            reject("Can't fetch admin center data");
        });
    });
};
/** Admin Center's pages for Teams (`/teams-app/...`), which IframeManager shows in a dialog through the app's relay. */
const teamsAppUrl = (adminCenterBaseUrl, path) => adminCenterBaseUrl.replace(/\/+$/, "") + "/teams-app/" + path + (path.includes("?") ? "&" : "?") + "fromTeams=true";
/**
 * Get Url to show app plans
 * @param user user
 * @param appId appId
 * @param teamsAppBaseUrl Admin Center base url, for its page shown in a Teams dialog
 * @param url Admin Center base url, for its page shown in a browser (Map, mobile)
 */
export const getAppPlansUrl = (user, appId, userMail, teamsAppBaseUrl, url) => {
    if (teamsAppBaseUrl) {
        return teamsAppUrl(teamsAppBaseUrl, user.TenantId + "/" + user.AadId + "/show-plans/" + appId
            + "?userName=" + encodeURIComponent(user.DisplayName) + "&userMail=" + encodeURIComponent(userMail));
    }
    return url + "/services/app/" + appId + "?userMail=" + userMail;
};
export const getProductUrlByWS = (user, licencePlanId, userMail, teamsAppBaseUrl, url) => {
    if (teamsAppBaseUrl) {
        return teamsAppUrl(teamsAppBaseUrl, "products/" + user.AadId + "/" + licencePlanId + "?userMail=" + encodeURIComponent(userMail));
    }
    return url + "/products/" + licencePlanId + "?userMail=" + userMail;
};
export const getMoreAppsUrl = (appId, userMail, adminCenterBaseUrl) => {
    return teamsAppUrl(adminCenterBaseUrl, "more-apps?appId=" + appId + "&userMail=" + encodeURIComponent(userMail));
};
/**
 * Get url to show product
 */
export const getProductUrl = (licencePlanId, showLicences = false, url) => {
    return url + "/products/" + licencePlanId + (showLicences ? "?tab=licences" : "");
};
/**
 * Posts an access request form to Admin Center with the user's Teams SSO token: `/teams-app`
 * write endpoints identify the requester from the token alone and answer 401 without one.
 * The form content type is explicit, since the shared instance defaults to JSON and these
 * endpoints bind `[FromForm]`.
 */
const postAccessRequest = async (url, form) => {
    await AxiosConfig.instance.post(url, form, { headers: { "Content-Type": "application/x-www-form-urlencoded" } });
};
const accessRequestForm = (user, appId, reason, locale) => {
    const data = new URLSearchParams();
    data.append("user", JSON.stringify(user));
    data.append("appId", appId);
    data.append("reason", reason.replace(/['"]/g, " "));
    data.append("locale", locale);
    return data;
};
/**
 * Create a new access request, sent to every administrator of the tenant
 * @param user user
 * @param appId app id
 * @param reason reason
 * @param locale string
 * @param url Admin Center base url
 * @throws when Admin Center refuses the request (401, 409 already pending, network, CORS)
 */
export const createAccessRequest = async (user, appId, reason, locale, url) => {
    await postAccessRequest(url + "/teams-app/access-request", accessRequestForm(user, appId, reason, locale));
};
/**
 * Create an access request aimed at one super administrator of the tenant
 * @throws when Admin Center refuses the request
 */
export const createAccessRequestToASpecificSubscription = async (user, appId, reason, locale, superAdmin, url) => {
    const data = accessRequestForm(user, appId, reason, locale);
    data.append("superAdmin", JSON.stringify(superAdmin));
    await postAccessRequest(url + "/teams-app/access-request/specific-subscription", data);
};
